export default "__VITE_ASSET__550844b5__"